import React, { useEffect, useState } from "react";
import { LinearGradient } from "react-text-gradients";
import SideBar from "../../Common/SideBar";
import { useDispatch, useSelector } from "react-redux";
import {
  collapseSidebar,
  expandSidebar,
} from "../../../store/reducers/sidebarSlice";
import "./styles/SupportPage.css";
import {
  FieldValue,
  Firestore,
  arrayUnion,
  collection,
  doc,
  getDoc,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../../../config/firebase";
import {
  accountType,
  convertToFirestoreTimestamp,
  firestoreCollections,
  formatFirebaseTimestampForChat,
  userIssueStatus,
} from "../../../utils";
import { OvalLoader, ThreeDotLoader } from "../../Common/Loaders";
import { infoToast, successToast } from "../../../services/toastService";
import { Oval } from "react-loader-spinner";

const EachTicketRow = ({
  ticket,
  index,
  setActiveTicketData,
  setShowActiveTicket,
}) => {
  const [openTicketLoading, setOpenTicketLoading] = useState(false);

  const handleOpenTicket = ticket => {
    setActiveTicketData(ticket);
    setShowActiveTicket(true);
  };

  return (
    <div className="verificationTableRow">
      <div
        style={{ width: "6%", height: "100%" }}
        className="eachColumn eachTableBody"
      >
        {index}
      </div>
      <div
        style={{ width: "16%", height: "100%" }}
        className="eachColumn eachTableBody"
      >
        {ticket.ticketId}
      </div>
      <div
        style={{
          width: "16%",
          height: "100%",
          textDecoration: "underline",
          whiteSpace: "nowrap",
        }}
        className="eachColumn eachTableBody"
      >
        {ticket.userData.displayName}
      </div>
      <div
        style={{ width: "14%", height: "100%" }}
        className="eachColumn eachTableBody"
      >
        {ticket.accountType}
      </div>

      <div
        style={{ width: "12%", height: "100%" }}
        className="eachColumn eachTableBody"
      >
        {formatFirebaseTimestampForChat(ticket.createdAt)}
      </div>
      <div
        style={{ width: "13%", height: "100%" }}
        className="eachColumn eachTableBody"
      >
        {ticket.status}
      </div>

      <div
        style={{
          width: "13%",
          height: "100%",

          justifyContent: "space-evenly",
        }}
        className="eachColumn eachTableBody"
      >
        <div
          style={{
            color: "blue",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => handleOpenTicket(ticket)}
        >
          {openTicketLoading ? (
            <ThreeDotLoader visible={true} color="#3366CC" />
          ) : (
            "Open Ticket"
          )}
        </div>
      </div>
      <div
        style={{
          width: "5%",
          height: "100%",

          justifyContent: "space-evenly",
        }}
        className="eachColumn eachTableBody"
      >
        {ticket.status == userIssueStatus.ACTIVE && (
          <div
            style={{
              color: "green",
              backgroundColor: "red",
              width: "1.2vh",
              height: "1.2vh",
              borderRadius: "1vh",
              textDecoration: "underline",
            }}
          ></div>
        )}
      </div>
    </div>
  );
};

const ActiveTicketComponent = ({ ticket }) => {
  const [chatLoading, setChatLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [resolveTicketLoading, setResolveTicketLoading] = useState(false);
  const [text, setText] = useState("");

  const fetchChat = () => {
    setChatLoading(true);
    console.log("fetch called");
    const chatDocRef = doc(db, firestoreCollections.chats, ticket.chatId);
    const unsubscribe = onSnapshot(
      chatDocRef,
      docSnapshot => {
        const chatData = docSnapshot.data();
        setMessages(chatData.messages);
        setChatLoading(false);
      },
      err => {
        console.log(err, "<<< error fetching chat");
        infoToast("Error fetching chat.");
        setChatLoading(false);
      }
    );

    return unsubscribe;
  };

  useEffect(() => {
    console.log("use eff called");
    const unsubscribe = fetchChat();

    return () => {
      unsubscribe();
    };
  }, []);

  const sendMessage = async () => {
    if (text.trim() !== "") {
      setText("");

      // Create a new message object
      const newMessage = {
        createdAt: convertToFirestoreTimestamp(new Date()),
        readBy: [accountType.ADMIN],
        sender: accountType.ADMIN,
        text,
      };

      const chatRef = doc(db, firestoreCollections.chats, ticket.chatId);
      const updateDataChat = {
        messages: arrayUnion(newMessage),
        updatedAt: convertToFirestoreTimestamp(new Date()),
      };

      const supportTicketRef = doc(
        db,
        firestoreCollections.supportTickets,
        ticket.id
      );

      await updateDoc(chatRef, updateDataChat);

      if (!ticket.unreadMessage) {
        const updateDataTicket = { unreadMessage: true };
        await updateDoc(supportTicketRef, updateDataTicket).then(() =>
          console.log("doc updated")
        );
      }
    } else {
      infoToast("Invalid text message");
    }
  };

  const handleResolveTicket = async () => {
    if (!resolveTicketLoading) {
      setResolveTicketLoading(true);
      try {
        const supportTicketRef = doc(
          db,
          firestoreCollections.supportTickets,
          ticket.id
        );
        const updateDataTicket = {
          status: userIssueStatus.RESOLVED,
          resolvedAt: convertToFirestoreTimestamp(new Date()),
        };

        await updateDoc(supportTicketRef, updateDataTicket).then(() =>
          successToast("Ticket marked as Resolved.")
        );
      } catch (error) {
        console.log(error, "<<< error resolving ticket");
        infoToast("Internal server error.");
      } finally {
        setResolveTicketLoading(false);
      }
    }
  };

  return (
    <div className="chatContainer">
      <div className="chatInformation">
        <div className="chatInformationTitle">Ticket ID:</div>
        <div className="chatInformationBody">#{ticket.ticketId}</div>
        <div className="chatInformationTitle">Name:</div>
        <div className="chatInformationBody">{ticket.userData.displayName}</div>
        <div className="chatInformationTitle">User Type:</div>
        <div className="chatInformationBody">{ticket.accountType}</div>
        <div className="chatInformationTitle">Issue Title:</div>
        <div className="chatInformationBody">{ticket.title}</div>
        <div className="chatInformationTitle">Issue Description:</div>
        <div className="chatInformationBody">{ticket.description}</div>
        <div className="chatInformationTitle">Issue Opened On:</div>
        <div className="chatInformationBody">
          {formatFirebaseTimestampForChat(ticket.createdAt)}
        </div>
        {ticket.status == userIssueStatus.ACTIVE ? (
          <div
            className="resolveButton"
            style={{
              width: "70%",
              marginLeft: "10%",
              padding: "1.4vh",
              cursor: "pointer",
            }}
            onClick={handleResolveTicket}
          >
            {resolveTicketLoading ? (
              <ThreeDotLoader visible={true} color="#ffffff" />
            ) : (
              "Mark Issue As Resolved"
            )}
          </div>
        ) : (
          <>
            <div
              className="resolvedButton"
              style={{
                width: "70%",
                marginLeft: "10%",
                padding: "1vh",
              }}
            >
              Resolved
            </div>
            <div
              style={{
                width: "70%",
                marginLeft: "10%",
                padding: "1vh",
              }}
            >
              Resolved on : {formatFirebaseTimestampForChat(ticket.resolvedAt)}
            </div>
          </>
        )}
      </div>
      <div className="chatWindow">
        <div className="chatWindowInner">
          {chatLoading ? (
            <div className="eachColumn" style={{ height: "100%" }}>
              <ThreeDotLoader visible={true} color="#3366CC" />
            </div>
          ) : (
            messages.map((item, i) => (
              <div
                key={i}
                className={`${
                  item.sender === accountType.ADMIN
                    ? "chatMssgAdmin"
                    : "chatMssgUser"
                }`}
              >
                {item.text}
              </div>
            ))
          )}
        </div>
        {ticket.status == userIssueStatus.ACTIVE && (
          <div className="chatTextInputContainer">
            <div className="chatTextInputOuter">
              <textarea
                placeholder="type here..."
                multiple
                className="chatTextInput"
                value={text}
                onChange={e => setText(e.target.value)}
              />
            </div>
            <div className="chatTextSend" onClick={sendMessage}>
              <div className="chatTextSendButton">Send</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default function SupportScreen() {
  const sidebar = useSelector(state => state.sidebar);
  const dispatch = useDispatch();
  const [supportTickets, setSupportTickets] = useState([]);
  const [showActiveTicket, setShowActiveTicket] = useState(false);
  const [supportTicketsLoading, setSupportTicketsLoading] = useState(false);
  const [activeTicketData, setActiveTicketData] = useState(null);

  const fetchSupportRequests = () => {
    setSupportTicketsLoading(true);
    const q = query(
      collection(db, firestoreCollections.supportTickets),
      orderBy("status", "asc"),
      orderBy("updatedAt", "desc")
    );

    const unsubscribe = onSnapshot(
      q,
      async querySnapshot => {
        const newData = await Promise.all(
          querySnapshot.docs.map(async ticketDoc => {
            console.log("snap called");
            const ticketData = ticketDoc.data();
            ticketData.id = ticketDoc.id;

            const userDoc = await getDoc(
              doc(
                db,
                ticketData.accountType == accountType.CUSTOMER
                  ? firestoreCollections.customers
                  : firestoreCollections.merchants,
                ticketData.accountId
              )
            );
            ticketData.userData = userDoc.data();

            if (activeTicketData?.id == ticketDoc.id) {
              console.log("active data updated");
              setActiveTicketData(ticketData);
            }

            return ticketData;
          })
        );
        setSupportTickets(newData);
        setSupportTicketsLoading(false);
      },
      err => {
        console.log(err, "<<< snaps");
      }
    );

    return unsubscribe;
  };

  useEffect(() => {
    const unsubscribe = fetchSupportRequests();

    return () => {
      unsubscribe();
    };
  }, []);

  // useEffect(() => {
  //   const fetchChat = async () => {
  //     if (activeTicketData) {
  //       const chatRef = doc(
  //         db,
  //         firestoreCollections.chats,
  //         activeTicketData.chatId
  //       );
  //       const chatSnap = await getDoc(chatRef);
  //       const chatData = chatSnap.data();

  //       // setChatData
  //     }
  //   };

  //   fetchChat();
  // }, [activeTicketData]);

  return (
    <div className="MainContainer">
      <SideBar />
      <div
        style={{ width: sidebar.expand ? "84vw" : "95vw" }}
        className="ScreenContainer"
      >
        {/* upper search bar start */}

        <div className="upperSearchBarContainer">
          <div className="upperBarSearchBar">
            <input placeholder="Search..." className="upperBarSearchBarInput" />
          </div>
          <div className="upperBarSearchBox upperBarSearchBoxNotification">
            <img
              src={require("../../../assets/exit.png")}
              alt="notification-bell"
            />
          </div>
          <div
            className="upperBarSearchBox upperBarSearchBoxProfile"
            style={{ border: "none" }}
          >
            <img
              src={require("../../../assets/profile.png")}
              alt="profile-pic"
            />
          </div>
        </div>

        {/* page heading start */}

        <div className="pageHeadingContainer">
          <div className="pageHeadingInnerContainer">
            {showActiveTicket ? (
              <div
                onClick={() => {
                  setActiveTicketData(null);
                  setShowActiveTicket(false);
                }}
              >
                <img
                  style={{ width: "3.2vh", height: "3.2vh" }}
                  src={require("../../../assets/back.png")}
                />
              </div>
            ) : (
              <>
                <img
                  src={require("../../../assets/dashboardColourIcon.png")}
                  alt="profile-pic"
                  className="pageHeadingImageDashboard"
                />
                <div className="pageHeading">
                  <LinearGradient gradient={["to left", "#03BAF9,#7B32EE"]}>
                    Support Tickets
                  </LinearGradient>
                </div>
              </>
            )}
          </div>
          <div className="pageHeadingSecondaryText">
            Support
            {activeTicketData ? `/${activeTicketData.ticketId}` : ""}
          </div>
        </div>
        {/* general numbers container start */}
        {supportTicketsLoading ? (
          <div className="eachColumn eachTableHead" style={{ height: "5%" }}>
            <ThreeDotLoader visible={true} color="#3366CC" />
          </div>
        ) : (
          <>
            {showActiveTicket ? (
              <ActiveTicketComponent ticket={activeTicketData} />
            ) : (
              <div className="verificationTableContainer">
                <div className="verificationTableRow">
                  <div
                    style={{ width: "6%", height: "100%" }}
                    className="eachColumn eachTableHead"
                  >
                    Sr. No.
                  </div>
                  <div
                    style={{ width: "16%", height: "100%" }}
                    className="eachColumn eachTableHead"
                  >
                    Ticket ID
                  </div>
                  <div
                    style={{ width: "16%", height: "100%" }}
                    className="eachColumn eachTableHead"
                  >
                    Name
                  </div>
                  <div
                    style={{ width: "14%", height: "100%" }}
                    className="eachColumn eachTableHead"
                  >
                    Type
                  </div>

                  <div
                    style={{ width: "12%", height: "100%" }}
                    className="eachColumn eachTableHead"
                  >
                    Date Opened
                  </div>
                  <div
                    style={{ width: "13%", height: "100%" }}
                    className="eachColumn eachTableHead"
                  >
                    Status
                  </div>
                  <div
                    style={{
                      width: "13%",
                      height: "100%",
                    }}
                    className="eachColumn eachTableHead"
                  ></div>
                  <div
                    style={{
                      width: "5%",
                      height: "100%",
                    }}
                    className="eachColumn eachTableHead"
                  ></div>
                </div>
                {supportTickets.map((ticket, i) => (
                  <EachTicketRow
                    key={ticket.id}
                    ticket={ticket}
                    index={i + 1}
                    setActiveTicketData={setActiveTicketData}
                    setShowActiveTicket={setShowActiveTicket}
                  />
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
